import { BrowserRouter, Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Fonts
import "./assets/fonts/SegoeUIBoldItalic.ttf";
import "./assets/fonts/SegoeUIBold.ttf";
import "./assets/fonts/SegoeUIItalic.ttf";
import "./assets/fonts/SegoeUI.ttf";

import { PAGE_PATHS } from "./pages/page-paths";
import usePromise from "./utils/hooks/usePromise";
import { resolveServices } from "./services";
import VLEStatsPage from "./pages/VLEStats";
import HomePage from "./pages/Home";
import CountryStatsPage from "./pages/CountryStats";
import Loader from "./assets/animated-images/loader";
import UpdateUserCourseCompletionPage from "./pages/UpdateUserCourseCompletion";
import { useAuth } from "./utils/hooks/useAuth";
import LoginPage from "./pages/Login";
import CandidateStatsPage from "./pages/CandidateStats";
import Layout from "./components/Layout";
import UserBulkUpload from "./pages/UserBulkUpload";
import CreateUpdatePartner from "./pages/CreateUpdatePartner";
import PartnerCandidatesList from "./pages/PartnerCandidatesList";
import { jwtDecode } from "jwt-decode";
import { getCookieObject } from "./utils/cookie";
import { useMemo } from "react";
import CreateAdmin from "./pages/CreateAdmin";
import FreezeWindow from "./pages/FreezeWindow";
import AddIibfExamDate from "./pages/AddIibfExamDate";
import GetPassword from "./pages/GetPassword";
import UpdatePassword from "./pages/UpdatePassword";
import { useState } from "react";

function App() {
  const [role, setRole] = useState<any>(null);
  const { result: servicesResolved } = usePromise(
    { fn: resolveServices, runOnMount: { args: [] } },
    [],
  );
  const decodedToken: any = useMemo(() => {
    const { access_token: accessToken } = getCookieObject();
    if (!accessToken) return null;
    try {
      return jwtDecode(accessToken);
    } catch (err) {
      console.error("Invalid token", err);
      return null;
    }
  }, []);

  const isPartnerLoggedIn = decodedToken?.partnerId;
  const isStateAdminLoggedIn = decodedToken?.role == "STATE_ADMIN";
  console.log("isStateAdminLoggedIn", isStateAdminLoggedIn);

  const { is_authenticated } = useAuth();

  if (servicesResolved) {
    return (
      <BrowserRouter>
        <Routes>
          {is_authenticated
            ? [
                <Route
                  path={PAGE_PATHS.VLE_STATS}
                  element={
                    <Layout>
                      <VLEStatsPage />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.GET_PASSWORD}
                  element={
                    <Layout>
                      <GetPassword />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.UPDATE_PASSWORD}
                  element={
                    <Layout>
                      <UpdatePassword />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.COUNTRY_STATS}
                  element={
                    <Layout>
                      <CountryStatsPage />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.UPDATE_USER_COURSE_COMPLETION}
                  element={
                    <Layout>
                      <UpdateUserCourseCompletionPage />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.DRA_STATS}
                  element={
                    <Layout>
                      <CandidateStatsPage />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.BCBF_STATS}
                  element={
                    <Layout>
                      <CandidateStatsPage />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.ONBOARD_PARTNER}
                  element={
                    <Layout>
                      <CreateUpdatePartner />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.PARTNER_ONBOARD_USERS}
                  element={
                    <Layout>
                      <UserBulkUpload />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.PARTNER_CANDIDATES_LIST}
                  element={
                    <Layout>
                      <PartnerCandidatesList />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.CREATE_ADMIN}
                  element={
                    <Layout>
                      <CreateAdmin />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.FREEZE_WINDOW}
                  element={
                    <Layout>
                      <FreezeWindow />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.ADD_EXAM_DATE}
                  element={
                    <Layout>
                      <AddIibfExamDate />
                    </Layout>
                  }
                />,
                <Route
                  path={PAGE_PATHS.DEFAULT}
                  element={
                    <Layout>
                      {isPartnerLoggedIn ? (
                        <PartnerCandidatesList />
                      ) : isStateAdminLoggedIn ? (
                        <CandidateStatsPage />
                      ) : (
                        <CountryStatsPage />
                      )}
                    </Layout>
                  }
                />,
              ]
            : [<Route path={PAGE_PATHS.DEFAULT} Component={LoginPage} />]}
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </BrowserRouter>
    );
  } else
    return (
      <div className="centered-page">
        <Loader style={{ height: "40px" }} color="#999" />
      </div>
    );
}

export default App;
